import { ANKRLogo, USDCLogo, USDTLogo } from '@ankr.com/ui';

import { ECurrency, TCryptoCurrency } from 'modules/payments/types';

export function getTokenIcon(token: TCryptoCurrency) {
  switch (token) {
    case ECurrency.USDC:
      return USDCLogo;
    case ECurrency.USDT:
      return USDTLogo;
    case ECurrency.ANKR:
      return ANKRLogo;
    default:
      return null;
  }
}
